import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBR-9zI7UP9X4lDtw-f0ORdlGMTzeBANFI",
    authDomain: "theigram.firebaseapp.com",
    databaseURL: "https://theigram.firebaseio.com",
    projectId: "theigram",
    storageBucket: "theigram.appspot.com",
    messagingSenderId: "1051447545163",
    appId: "1:1051447545163:web:d9086138c04a2082436cce",
    measurementId: "G-603ZNDNCWZ"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { db, auth, storage };